module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "372",
      "src": "images/f0022-01.jpg",
      "width": "550"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_vm._v("BLUE-FLECKED ROCKS")])]), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("W")])]), _vm._v("HEN THE cakes were richly browned, the old man stacked a plate for Jake Irons and handed him a jug of honey. Then he fanned a single cake in the air to cool and sprinkled it generously with sugar. He smiled sheepishly. “Brighty likes sugar better’n honey,” he explained. “ ’Tain’t so slobbery.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the trapper watched, Brighty took the rolled pancake from the old man’s hand and began chewing rhythmically, thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You two always dine on cakes and honey?” Irons asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_vm._v("The note of scorn in his voice was lost to Old Timer. “Only when we’re celebratin’, stranger. And now how about samplin’ ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("a cup o’ my coffee? Uncle Jim says it’s black as a thief’s heart.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Jake Irons glanced up sharply, trying to read the old man’s thoughts, but Hezekiah Appleyard was not even looking his way. Irons flashed an ugly grin. “I like my coffee black as that.” he retorted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two men and the burro finished their supper in silence while a handful of stars pricked holes in the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a while the old prospector took a gold watch from his pocket and began winding it with a little gold key. “ ’Tain’t but seven,” he said, winding. “I’ll pile more wood on the fire, and how about us chinnin’ some before beddin’ down?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Much obliged, Old Timer, but soon as the moon shines over the brink, I’m crossing the river and heading up to the South Rim. By the way,” he asked, making his voice sound casual, “what you celebrating?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old man held his tongue, thinking. He picked up a sharp-edged stone and began cleaning Brighty’s hoofs as though he could clear his thoughts at the same time. He failed to see that the stone he was using for a hoofpick was veined with blue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Irons’ quick eyes caught the tell-tale color or copper ore. His mind began racing. “Now, don’t you bother spilling your secrets to me, Old Timer,” he wheedled. “It’s just like I said. I’m topping out of this black pit and I don’t figure to come back. Not ever. I’m tired trapping. Ain’t enough beaver in these waters to keep me in grub.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old man was only half listening. He was eyeing the lean hard body, noticing the sleeve stretched tight over the bulge of muscle, the big broad-fingered hands with their broken fingernails, the solid legs encased in their puttees.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“You mean ye’re done trappin’? And outa work?” he asked.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s exactly what I mean. I ain’t one to complain, but tonight’s the first square meal I’ve had in weeks. And when I saw your cozy camp with the critter and all, right away I says to myself, here’s a man I can trust.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old Timer looked all around as if to make certain they were alone. “‘If ye’re really done trappin’,” he cried, “mebbe you could work fer me! I need a young muscly feller, ’cause . . .” His voice pitched high as a boy’s. “ ’Cause me and Brighty’s found a extry-ordinary vein o’ ore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jake Irons smiled to himself at how neatly his flattery had worked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup!” the white head nodded. “With you and me to dig, and Brighty to pack the stuff out, us three can get rich quick. Y’see, I got a sister with a crippled youngster, and sick folks needs lots o’ money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, I know,” Irons said sarcastically. “You’re just the kind to give the stuff away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mistaking the mockery for approval, the old man sat down, leaning happily against Brighty. “Ye’ll do, Jake Irons!” His eyes were far away and joyous. “Ye’ll do as a partner in the Little Mimi Mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a long moment the muffled roar of the river filled in the silence, and somewhere down the canyon a coyote howled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even by starlight ye’ll see how rich the stuff is.” Hoisting himself up, the old man moved nearer and spilled the blue-flecked rocks into greedy, outstretched hands. “Here! Study on ’em, feller!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Over and over Irons turned the nuggets in his hand. Then ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("he made a wide circuit around Brighty and fed the fire the better to see. “Where’d you find these?” he asked, trying to hide the eagerness in his voice.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, friend, me and Brighty was dawdlin’ along, loafin’ and pokin’ along down close to the Colorado, when we spied us one o’ them horny toads.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then Brighty flips this toad over with his li’l ole mealy nose and underneath, guess what?”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "296",
      "src": "images/f0025-01.jpg",
      "width": "550"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without waiting for Irons to guess, the old man went on. “There, underneath, was one o’ them blue-green rocks. ’Twas only a broken-off lump, but I figgered where there’s one, there’s more.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. Like mice.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“ ’Zackly. And I looks up overhead and I sees some more o’ this color in an overhang of rock. And me and Brighty fergits the horny toad and I begins a-diggin’ and a-diggin’. Got so feverish ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("I hardly stopped fer meals. If it hadn’t been fer Brighty bellerin’ at sundown, I’d like to starved to death.”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Jake Irons returned the nuggets and flopped down in the sand on the other side of the fire. “Lots of veins look good to begin with,” he said, “but they pinch off to nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ye’re right. Most of ’em does. But not this one. No, siree! It got bigger and bigger the further I dug. Only jest today was I certain sure. Come mornin’, I’ll take ye in the tunnel and show ye.” He pointed north. “ ’Tain’t far. Jest over there a piece. Wait’ll you see the tree-ladder I built up to the tunnel. She swings out a bit over the river, but she’s stout enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jake Irons plucked at his beard, figuring a way to accept the invitation and seem casual about it. “I see you got a tent big enough for two,” he said at last. “And it’s been a long time since I slept out of the wind. Besides,” he added, looking toward the river, “it’d be risky tryin’ to cross on that cableway in the dark. Guess I’ll stay till morning, anyway. But your burro,” he hesitated, “does he hug camp all night?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ye’re durn tootin’ he does! And it makes me mighty proud. Until I chanced on this-here copper mine, I had only two things I took a pride in—one was my grandpap’s gold watch with the gold key to wind it, and the other’s Brighty. Found the little feller runnin’ wild along Bright Angel Creek.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you named him Bright Angel, him being so bright, I suppose.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("“Yup. Only he weren’t no Bright Angel at the time. Great horns, but he was a sight! Some porcupine had made a pincushion outa his face.” The old man clapped Brighty’s rump. “ ’Member, feller? If I hadn’t come along about then and roped ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("ye and pulled out the quills with my pliers, ye’d have gone under, fer sure.”")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Chuckling, the prospector turned now to Jake Irons. “Guess he was so hungry and hurted, he figgered I was his best friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irons’ eyes avoided Brighty and he strove to keep the contempt out of his voice. “And so he’s latched onto you ever since, I take it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The white head nodded. “ ’Cept for summertimes. Y’see, Irons, he’s like a migrator-bird. Winters, he lives down here in the canyon where it’s warm, and summers, he hightails it up to the North Rim where it’s cool. Y’know,” he went on, leaning back against Brighty, “ ’twas him that made the trail all the way up to the North Rim. And mind ye, Irons, that wall is so steep he couldn’t go the short way; he had to zig and zag! It’s over twenty-one mile to the top!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old man stretched his legs and dug his heels in the sand. “If ever you decides to top out north ’stead o’ south, Brighty here knows the way. Don’t fergit that. And if he’s a mind to, he can pack a pick and pan as nice as you please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t say!” Jake Irons’ eyes glinted in the firelight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But I do say! And what’s more, Brighty knows character. If ever he out-and-out kicks a man, there’s a man can’t be trusted. Once when we went to town, Brighty near kicked a barber up on the chandelier. Next I heard about him, that haircutter feller was servin’ time fer thievin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trapper went over to feel his beaver skin, but his mind was listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now, on the other hand,” Old Timer went on, “take Uncle Jimmy Owen up on the North Rim. Know him, son?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("“Just by hearsay,” Irons answered. “He’s the government lion hunter, ain’t he?”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah. He’s the one. Well, Brighty’s got good reason to mistrust Uncle Jimmy because he smells to high heaven of lions, and anyone knows a burro hates lions worser’n work. But does he hate Uncle Jimmy?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Indeedy no! He sidles up to him to get his back scratched, same as he does to me. Like I say, Brighty knows character even when it’s wrapped up in lion smell. Why, if’n I was to die tonight, Uncle Jimmy’d step right into my boots, fur as Brighty goes. Right into my boots!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Irons sharpened his knife blade on a rock, thinking. He hardly heard the next words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Y’see,” Old Timer was saying, “Uncle Jimmy understands, just like I do, that Brighty’s a free spirit. Seems like he’s got to be free to breathe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The talk petered out and the fire burned low. Yawning, the two men went into the tent and settled down for the night, the old man on his cot, the young man wrapped in his blanket. Between them the big gold watch hung from the ridgepole, ticking the minutes away.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "232",
      "src": "images/f0028-01.jpg",
      "width": "200"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c1b682c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 84
// module chunks = 0